import { takeLatest, put, call, select, take } from "redux-saga/effects";
import {
    getPaginatedGuestInsightsIfNeeded,
    getCurrentGuestDetailIfNeeded
} from './sagas';
import {
    GET_PAGINATED_GUEST_INSIGHTS,
    GETTING_PAGINATED_GUEST_INSIGHTS_FAILED,
    GET_CURRENT_GUEST_DETAIL,
    GETTING_CURRENT_GUEST_DETAIL_FAILED
} from './actions';
import { actions as userMessaging } from '../userMessaging';

function* waitForUserReady() {
    const userReady = yield select(store => store.user.ready);
    if (!userReady) {
        yield take(UserActions.LOGIN_READY);
    }
}

function* HandleFailuresSaga() {
    yield takeLatest(
        [
            GETTING_PAGINATED_GUEST_INSIGHTS_FAILED,
            GETTING_CURRENT_GUEST_DETAIL_FAILED
        ], 
        function*(action) {
            yield put(
                userMessaging.setMessageForFailedAction({
                    type: action.type,
                    error: action.payload
                })
            );
    });
}

function* PaginatedGuestInsightsGetManySaga() {
    yield takeLatest(GET_PAGINATED_GUEST_INSIGHTS, function*(action) {
        yield call(waitForUserReady);
        yield call(getPaginatedGuestInsightsIfNeeded, action);
    });
}

function* GetCurrentGuestDetailSaga() {
    yield takeLatest(GET_CURRENT_GUEST_DETAIL, function*(action) {
        yield call(waitForUserReady);
        yield call(getCurrentGuestDetailIfNeeded, action);
    });
}

export default [
    PaginatedGuestInsightsGetManySaga,
    GetCurrentGuestDetailSaga,
    HandleFailuresSaga
];